import React, { useEffect, useState } from 'react';
import { Field, Form, getFormValues, reduxForm, touch } from 'redux-form';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import { __ } from '../../core/utils';
import Select from '../../components/Select';
import DateTimePicker from '../../components/DateTimePicker';
import Input from '../../components/Input';
import Textarea from '../../components/Textarea';
import Checkbox from '../../components/Checkbox';
import Button from '../../components/Button';
import {
  listPossibleLeaveParticipants,
  listPossibleLeaveReasons,
} from '../../redux/actions/table/timesheets';
import InfoPositiveIcon from '../../assets/images/info-positive-16x16.svg';
import styles from '../../styles/forms/timesheets/AddTimesheetEntryTimeOffForm.scss';

const AddTimesheetEntryTimeOffForm = (props) => {
  const VACATION_LEAVE_REASON_ID = 1;
  const TOIL_LEAVE_REASON_ID = 12;
  const { values = {}, handleSubmit, onClose, onSubmit, auth, selectedUserId } =
    props;
  const [possibleLeaveReasons, setPossibleLeaveReasons] = useState([]);
  const [possibleLeaveParticipants, setPossibleLeaveParticipants] = useState([]);
  const possibleMinutes = [
    { value: '0', label: '00' },
    { value: 15, label: '15' },
    { value: 30, label: '30' },
    { value: 45, label: '45' },
  ];
  useEffect(() => {
    listPossibleLeaveReasons().then(({ response }) => {
      setPossibleLeaveReasons(response.data || []);
    });

    listPossibleLeaveParticipants().then(({ response }) => {
      setPossibleLeaveParticipants(response.data || []);
    });
  }, []);

  const activeUserId = Number(selectedUserId) || Number(auth?.id);
  const selectedUser = _.find(possibleLeaveParticipants, ['id', activeUserId]);
  const availableCompensatoryHours =
    Number(selectedUser?.available_compensatory_hours) || 0;
  const compensatoryHoursBase =
    Number(selectedUser?.compensatory_hours_base) || 0;
  const vacationDaysRemaining =
    Number(selectedUser?.vacation_days_remaining) || 0;
  const vacationDaysBase = Number(selectedUser?.vacation_days_base) || 0;
  const selectedReasonId = Number(values?.reason) || 0;
  const showVacationInfo = selectedReasonId === VACATION_LEAVE_REASON_ID;
  const showToilInfo = selectedReasonId === TOIL_LEAVE_REASON_ID;

  const _handleSubmit = (formData) => {
    const reasonOption = _.find(possibleLeaveReasons, ['id', formData.reason]);

    return onSubmit({
      ...formData,
      reason_label: _.get(reasonOption, 'name', '-'),
    });
  };

  return (
    <Form className={styles.wrapper} onSubmit={handleSubmit(_handleSubmit)}>
      <div className={styles.form}>
        <div className={styles.flex}>
          <Field
            name='all_day'
            component={Checkbox}
            label={__('add-timesheet-form.all_day')}
            className={styles.checkbox}
          />
        </div>

        {values?.all_day ? (
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                name='date'
                component={DateTimePicker}
                label={__('table.columns.task-date-time')}
                footer
                range
                presets
              />
            </div>
          </div>
        ) : (
          <div className={styles.flex}>
            <div className={styles.f2}>
              <Field
                name='date'
                component={DateTimePicker}
                label={__('table.columns.timesheet-date')}
                footer
              />
            </div>
            <div className={styles.f2}>
              <Field
                name='hours'
                component={Input}
                label={__('table.columns.timesheet-hours')}
                numeric
                maxLength={2}
                hint={__('timesheets.hint.in-hours')}
              />
            </div>
            <div className={styles.f2}>
              <Field
                name='minutes'
                component={Select}
                searchable
                options={possibleMinutes}
                label={__('table.columns.timesheet-minutes')}
              />
            </div>
          </div>
        )}

        <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              name='reason'
              component={Select}
              searchable
              options={_.map(possibleLeaveReasons, (leaveReason) => ({
                value: leaveReason.id,
                label: leaveReason.name,
              }))}
              label={__('table.columns.timesheet-reason')}
              placeholder={__('add-timesheet-form.select-reason')}
            />
            {(showVacationInfo || showToilInfo) && (
              <div className={styles.reasonInfo}>
                <InfoPositiveIcon className={styles.reasonInfoIcon} />
                <span className={styles.reasonInfoText}>
                  {showVacationInfo
                    ? `${__('Available vacation days:')} ${vacationDaysRemaining} d / ${vacationDaysBase} d`
                    : `${__('Available overtime hours:')} ${availableCompensatoryHours} h / ${compensatoryHoursBase} h`}
                </span>
              </div>
            )}
          </div>
        </div>

        <Field
          name='description'
          component={Textarea}
          label={__('add-timesheet-form.description')}
          maxLength={200}
          rows={1}
          maxRows={5}
          placeholder={__('add-timesheet-form.add-description')}
        />

        <div className={styles.footer}>
          <Button
            lightGray
            medium
            middleText={__('button.cancel')}
            onClick={onClose}
          />
          <Button
            lightBlue
            medium
            middleText={__('button.create')}
            submit
          />
        </div>
      </div>
    </Form>
  );
};

export default reduxForm({
  form: 'timesheet_entries.add_time_off',
  enableReinitialize: true,
  onSubmitFail: (_errors, dispatch) => {
    dispatch(
      touch('timesheet_entries.add_time_off', 'date', 'minutes', 'reason')
    );
  },
})(
  connect((state) => ({
    values: getFormValues('timesheet_entries.add_time_off')(state),
    auth: state.auth,
  }))(AddTimesheetEntryTimeOffForm)
);
